import BaseService from "../baseService";
class NfeNcm extends BaseService {
    constructor(id) {
        const resource = "ncm-contabilizar";
        let relationship = {
            'importprodutos': 'import-produtos',
        };
        super(id, relationship, resource);
    }
}

export default (id) => new NfeNcm(id);